import { Column, ColumnsInterface } from '@irian-ro/util-table';
import { FilterMatchMode } from 'primeng/api';

export class ETransportActions {
  uuid!: string;

  owner: string | undefined;

  @Column({
    header: 'eTransportActions.list.uit',
    filterType: 'input',
    filterMatchMode: FilterMatchMode.CONTAINS,
  })
  uit: string | undefined;

  @Column({
    header: 'eTransportActions.list.uploadIndex',
    filterType: 'input',
    filterMatchMode: FilterMatchMode.EQUALS,
  })
  uploadIndex: string | undefined;

  @Column({
    header: 'eTransportActions.list.createdBy',
    filterType: 'input',
    filterMatchMode: FilterMatchMode.CONTAINS,
  })
  createdBy: string | undefined;

  @Column({
    header: 'eTransportActions.list.createdAt',
    filterType: 'date-range',
    filterMatchMode: FilterMatchMode.EQUALS,
  })
  createdAt: string | undefined;

  @Column({
    header: 'eTransportActions.list.actionType',
    filterType: 'input',
    filterMatchMode: FilterMatchMode.CONTAINS,
  })
  actionType: string | undefined;

  @Column({
    header: 'eTransportActions.list.vehicleModificationDate',
    filterType: 'date-range',
    filterMatchMode: FilterMatchMode.EQUALS,
  })
  vehicleModificationDate: string | undefined;

  @Column({
    header: 'eTransportActions.list.uploadStatus',
    filterType: 'input',
    filterMatchMode: FilterMatchMode.CONTAINS,
  })
  actionUploadStatus: string | undefined;

  @Column({
    header: 'eTransportActions.list.checkStatus',
    filterType: 'input',
    filterMatchMode: FilterMatchMode.CONTAINS,
  })
  actionCheckStatus: string | undefined;

  @Column({
    header: 'eTransportActions.list.licensePlates',
    filterType: 'input',
    filterMatchMode: FilterMatchMode.CONTAINS,
  })
  licensePlates: string | undefined;

  @Column({
    header: 'eTransportActions.list.observations',
    filterType: 'input',
    filterMatchMode: FilterMatchMode.CONTAINS,
  })
  observations: string | undefined;

  @Column({
    header: 'eTransportActions.list.anafMessage',
    filterType: 'input',
    filterMatchMode: FilterMatchMode.CONTAINS,
  })
  anafMessage: string | undefined;

  static _columns: ColumnsInterface[] | undefined = undefined;
}
